
<div class="sections search-bar">
  <pre class="item-description">
{{ pastedItemText }}
  </pre>
  <!-- <pre class="item-details">
{{ gameItem | json }}
  </pre> -->
  <div class="item-details">
    <div class="item-label-container">
      <app-item-label [baseType]="gameItem.baseType"
        [tooltipOnly]="true"
        [gameItem]="gameItem"
        [jewellery]="isJewellery"
        [enableGearTierNavigation]="isGear"
        [enableJewelleryTierNavigation]="isJewellery">
      </app-item-label>
    </div>
  </div>
  <div class="filter-results">
    <div class="summary">
      <app-simulator-result-summary [result]="simulatorResult"></app-simulator-result-summary>
    </div>

    @if (simulatorResult && simulatorResult.displayOptions) {
      <div class="label-viewer" app-label-viewer [displayOptions]="simulatorResult.displayOptions" [forceVisible]="holdAltToggle"
        [rareName]="((gameItem.rarity === 'Rare' || gameItem.rarity === 'Unique') && gameItem.identified !== false) ? gameItem.name : undefined"
        [exampleName]="exampleName"
        [stackSize]="gameItem.stackSize"
        [gearBaseType]="isGear ? gameItem.baseType : undefined"
        [jewelleryBaseType]="isJewellery ? gameItem.baseType : undefined"
        [unidentifiedItemTier]="gameItem.unidentifiedItemTier"
        [rarity]="gameItem.rarity === 'Currency' ? undefined : gameItem.rarity"
        [sockets]="socketsDisplay"
        [influence]="gameItem.hasInfluence"
        [memoryStrands]="gameItem.memoryStrands ? true : false"
        [fractured]="gameItem.fracturedItem"
        [synthesised]="gameItem.synthesisedItem"
        [isCurrency]="gameItem.rarity === 'Currency'"
        [isWaystone]="gameItem.itemClass === 'Waystones' || gameItem.itemClass === 'Maps' || gameItem.itemClass === 'Tablets'"
        [isPoe1Gem]="gameItem.itemClass === 'Skill Gems' || gameItem.itemClass === 'Support Gems'"
        [isDivinationCard]="gameItem.itemClass === 'Divination Cards'"
        [isQuestItem]="gameItem.itemClass === 'Quest Items' || gameItem.itemClass === 'Instance Local Items'"
      ></div>

      @if (isShownByDefaultAsGear || isShownByDefaultAsJewellery) {
        <span>
          You can hide this kind of item in the <a class="cursor-pointer" (click)="isShownByDefaultAsGear ? goToRemainingGear() : goToRemainingJewellery()">Hide Remaining Equipment</a> section.
        </span>
      }

      @if (!simulatorResult.shown) {
        <span>Expected the item to be visible instead? Double-check that the applicable rule is enabled.</span>
      }

      @if (settings.showPasteRuleExplainers() && hasRuleExplainers) {
        @for (explainer of ruleExplainers; track $index) {
          <div class="paste-explainer">
            <h3 class="info-title"><span class="icon icon-tutor"></span> @if (simulatorResult.shown) { Why am I seeing this? } @else { What are these items? }</h3>
            <p [innerHTML]="explainer"></p>
          </div>
        }
        <p><a class="remove-warning-link" (click)="hidePasteRuleExplainers()">(Stop showing rule explainers)</a></p>
      }

      @if (settings.showPasteUniqueExplainers() && uniqueExplainer) {
        <div class="paste-explainer">
          <h3 class="info-title"><span class="icon icon-tutor"></span> Why is this unique valuable?</h3>
          <p [innerHTML]="uniqueExplainer"></p>
        </div>
        <p><a class="remove-warning-link" (click)="hidePasteUniqueExplainers()">(Don't show unique explainers)</a></p>
      }

      <div class="regular-checkbox">
        <span class="input-group-btn" (click)="toggleHoldAlt()">
          <button class="btn toggle-btn" [class.off]="!holdAltToggle"></button>
        </span>
        Hold Alt
      </div>
    }

    @if (simulatorResult.rule && simulatorResult.rule.completeId) {
      <div class="controls">
        <button type="button" class="btn copy-btn" (click)="goToRule(simulatorResult.rule.completeId)">
          <span class="icon icon-arrow-up"></span> Go to Rule
        </button>
        <button type="button" class="btn copy-btn" (click)="goToOutput(simulatorResult.rule.completeId)">
          <span class="icon icon-arrow-down"></span> Go to Output
        </button>
      </div>
    }

  </div>
</div>
